import React from 'react';
import { TableCell, TableRow } from '@mui/material';

import { BearingReaction, MaximumBearingReaction } from '@paragon/contract-library';

import { PropertyTable } from './PropertyTable';

interface Props {
  maximumBearingReactions: ReadonlyArray<MaximumBearingReaction>;
  paperElevation?: number;
}

export const formatBearingReaction = (bearingReaction: BearingReaction | null) =>
  bearingReaction ? `${bearingReaction.force.toFixed(2)} (Load Case: ${bearingReaction.loadCaseIndex})` : 'N/A';

export function MaximumBearingReactionsTable(props: Props) {
  return (
    <PropertyTable
      paperElevation={props.paperElevation}
      title="Maximum Bearing Forces"
      columns={['Joint', 'Up (LC)', 'Down (LC)', 'Horizontal (LC)']}
    >
      {props.maximumBearingReactions.map((maximumBearingReaction) => (
        <TableRow key={maximumBearingReaction.jointName}>
          <TableCell>{maximumBearingReaction.jointName}</TableCell>
          <TableCell>{formatBearingReaction(maximumBearingReaction.upForce)}</TableCell>
          <TableCell>{formatBearingReaction(maximumBearingReaction.downForce)}</TableCell>
          <TableCell>{formatBearingReaction(maximumBearingReaction.horizontalForce)}</TableCell>
        </TableRow>
      ))}
    </PropertyTable>
  );
}
